export default __webpack_public_path__ + "static/media/border-black-friday.a668d65d.svg";